import { render, staticRenderFns } from "./BuyReportOnePerson.vue?vue&type=template&id=26db6ed0&"
import script from "./BuyReportOnePerson.vue?vue&type=script&lang=js&"
export * from "./BuyReportOnePerson.vue?vue&type=script&lang=js&"
import style0 from "./BuyReportOnePerson.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports